module.exports = __webpack_public_path__ + "img/yuni-no-update.821d125c.png";